import { Spacer } from '@procurify/ui'

import { PageBottomContainerStyled } from './styles/PageBottomContainerStyled'

export interface IPageBottomContainerProps {}

export const PageBottomContainer = ({}: IPageBottomContainerProps) => {
  return (
    <PageBottomContainerStyled>
      <Spacer />
      <div id='page-footer-container' />
    </PageBottomContainerStyled>
  )
}
